import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import AccountCreation from "@/components/signup/account-creation";
import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForTenUsersText,
    GetStartedText,
    Headings,
    InputSubmitButton
} from "../../../components";
import { UnderlineWord } from "../../components";

export const LoggedOutConfluenceFree = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <div data-testid="logged-out-confluence-free">
            <FeatureExposed
                experimentKey="cfind-2409-v2-cobranding-signup"
                group="test"
            >
                <FeatureExposed
                    experimentKey="jfind-1192-signup-button-update-cfind"
                    group="test"
                >
                    <FeatureExposed
                        experimentKey="cfind-3467-signup-with-image-overlay"
                        group="isTreatment"
                    >
                        <ConfluenceOverlayTemplate size="sm">
                            <div
                                css={
                                    !team26VisualUpdates &&
                                    headerOffsetForBlueBackgroundCss
                                }
                            >
                                {team26VisualUpdates ? (
                                    <Headings
                                        main={
                                            <GetStartedText productName="Confluence" />
                                        }
                                        sub={<FreeForTenUsersText />}
                                    />
                                ) : (
                                    <>
                                        <h1 css={h1Css}>
                                            <FormattedMessage
                                                id="BxpUiSignup.SignupForm.cfind2049.header"
                                                defaultMessage="Get <underline-word>started</underline-word> with Confluence"
                                                values={{
                                                    "underline-word":
                                                        UnderlineWord
                                                }}
                                            />
                                        </h1>
                                        <p css={subHeaderCss}>
                                            <FormattedMessage
                                                id="signupForm.accountCreation.subHeaderText"
                                                defaultMessage="It’s free for up to 10 users - no credit card needed."
                                            />
                                        </p>
                                    </>
                                )}
                                <AccountCreation
                                    Input={<InputSubmitButton />}
                                    Submit={null}
                                />
                            </div>
                        </ConfluenceOverlayTemplate>
                    </FeatureExposed>
                </FeatureExposed>
            </FeatureExposed>
        </div>
    );
};

const headerOffsetForBlueBackgroundCss = css({
    marginBlockStart: 54,
    [media.above.sm]: {
        marginBlockStart: 0
    }
});

const h1Css = css({
    color: wacToken("color.primary.black"),
    fontFamily: wacToken("font.charlie.display"),
    fontSize: "32px",
    fontWeight: 700,
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
